import React from 'react';
import Slider from 'react-slick';
import './HeroVideoBanner.scss';

const HeroVideoBanner = (props) => {
  console.log(props);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
  };

  const handleScrollDown = () => {
    const infoSection = document.getElementById('info-section');
    if (infoSection) {
      const offset = 220; // Adjust this value as needed
      const elementPosition = infoSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="hero-video-banner">
      <Slider {...settings}>
        {props?.fields?.BannerMedias?.map((slide, index) => {
          console.log('ji', slide.fields.CardMedia.value);

          return (
            <div key={slide.id} className="slide">
              <img
                src={`${slide.fields.CardMedia.value.src}`}
                alt={slide.fields.CardMedia.value.alt}
                className="slide-image"
                loading="lazy"
              />
            </div>
          );
        })}
      </Slider>
      <div className="scroll-down" onClick={handleScrollDown}>
        <span>Scroll Down</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
        >
          <g clipPath="url(#clip0_23_7259)">
            <path
              d="M6.4048 5.29618C6.79503 4.90596 7.4276 4.90561 7.81824 5.29541L11.6496 9.11839C12.0399 9.50789 12.6719 9.50789 13.0622 9.11839L16.8936 5.29541C17.2842 4.90561 17.9168 4.90596 18.307 5.29618L18.5047 5.49387C18.8952 5.8844 18.8952 6.51756 18.5047 6.90809L13.063 12.3498C12.6725 12.7403 12.0393 12.7403 11.6488 12.3498L6.20711 6.90809C5.81658 6.51756 5.81658 5.8844 6.20711 5.49387L6.4048 5.29618Z"
              fill="white"
            />
            <path
              d="M6.4048 10.6712C6.79503 10.281 7.4276 10.2806 7.81824 10.6704L11.6496 14.4934C12.0399 14.8829 12.6719 14.8829 13.0622 14.4934L16.8936 10.6704C17.2842 10.2806 17.9168 10.281 18.307 10.6712L18.5047 10.8689C18.8952 11.2594 18.8952 11.8926 18.5047 12.2831L13.063 17.7248C12.6725 18.1153 12.0393 18.1153 11.6488 17.7248L6.20711 12.2831C5.81658 11.8926 5.81658 11.2594 6.20711 10.8689L6.4048 10.6712Z"
              fill="white"
              fillOpacity="0.3"
            />
          </g>
          <defs>
            <clipPath id="clip0_23_7259">
              <rect width="24" height="24" fill="white" transform="translate(0.5)" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  );
};

export default React.memo(HeroVideoBanner);
